__webpack_require__.p = "/static/galaxy_ng/";